import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import {
  classifierGeneralItemField,
  classifierGeneralItemLangField,
} from '../../constants/classifier';

export default createValidation([
  {
    name: classifierGeneralItemField.CODE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: `${classifierGeneralItemField.LANG}.${classifierGeneralItemLangField.EN}`,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: `${classifierGeneralItemField.LANG}.${classifierGeneralItemLangField.ET}`,
    validators: (field) => validatorRequired()(field),
  },
]);
